export default {
  add: 'PLANNING_MUTATIONS_ADD',
  edit: 'PLANNING_MUTATIONS_EDIT',
  delete: 'PLANNING_MUTATIONS_DELETE',
  deleteCultivation: 'PLANNING_MUTATIONS_DELETE_CULTIVATION',
  deleteAll: 'PLANNING_MUTATIONS_DELETE_ALL',
  setLastItemKey: 'PLANNING_MUTATIONS_SET_LAST_ITEM_KEY'
}
